import React from "react";

const CheckoutForm = () => {

  return (
    <>
      <div className="promo-container">
        <div className="promo-image">
          <img src="/images/gbhCover.png" alt="Grey Blending Handbook" />
        </div>
        <div className="promo-text">
          <h2>Discover the Art of Grey Blending</h2>
          <p>
            Are you ready to embrace your natural greys with confidence and
            ease? 🌿 <strong>The Grey Blending Handbook</strong> is your
            ultimate guide to transitioning beautifully into blended,
            low-maintenance hair. Whether you’re spotting your first silver
            strands or looking to harmonize your greys with your natural tones,
            this handbook has everything you need.
          </p>
            <p>
              Expert techniques like highlights, lowlights, balayage, and
              glossing to reduce demarcation lines.
            </p>
            <p>
              Detailed profiles to help you identify the perfect grey blending
              approach for your unique style.
            </p>
            <p>
              Insights into products to
              preserve your hair’s health and shine.
            </p>
            <p>
              Step-by-step guidance to ensure your grey blending journey is
              seamless and uniquely yours.
            </p>
          <p>
            Authored by a seasoned hair professional with 20+ years of
            experience, this handbook empowers both clients and hairdressers to
            achieve stunning, natural results.
          </p>
          <p>
            <em>
              ✨ Say goodbye to harsh regrowth lines and hello to effortless,
              radiant beauty.
            </em>
          </p>
          <p>
            <strong>
              Start your transformation today—your grey blending journey begins
              here!
            </strong>
          </p>
          <a style={{padding: "15px 20px", width: "250px"}} href="https://store.lizziefoxcolourstudio.com/product/grey-blending-handbook/">
          <button className="promo-button">
            Purchase Now
          </button>
          </a>
        </div>
      </div>
    </>
  );
};

export default CheckoutForm;
